import React, {useCallback, useState} from 'react';

const UseModalState = () => {
    const [state,setState] = useState({show:false,value:null})

    const changeValue = (value) => {
        setState((prev)=>{
            return {
                ...prev,
                show: !prev.show,
                value: value
            }
        })
    }
    return [state,changeValue]
};

export default UseModalState;